import { FieldValues, UseFormRegister, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { Obj } from 'src/hooks/useSpdSearch';
import { getResponseValueByParam } from 'utilities';
import { listOfBrandFlowStops } from './listOfBrandFlowStops';

export type CarSearchResultValue = Obj | { value?: string | number | boolean | object };

export const getCarSearchIsValidFieldName = (stepContentId: number) => `${stepContentId}-car-search-is-valid`;

export const setCarSearchIsValid = ({
	fieldName,
	isValid,
	register,
	setValue,
	trigger,
}: {
	fieldName: string;
	isValid: boolean;
	register: UseFormRegister<FieldValues>;
	setValue?: UseFormSetValue<FieldValues>;
	trigger?: UseFormTrigger<FieldValues>;
}) => {
	const { onChange, name } = register(fieldName, { required: true });

	if (setValue) {
		setValue(name, isValid, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
	} else {
		onChange({
			target: {
				name,
				value: isValid,
			},
		});
	}

	trigger?.(name);
};

export const isSearchResultValid = (
	searchConfiguration: SpdSearchType['searchConfiguration'],
	value: CarSearchResultValue
) => {
	if (!value || Array.isArray(value) || typeof value !== 'object') {
		return false;
	}

	return searchConfiguration.outputFields.items.some((outputField) => {
		const mappedValue = value.value ?? getResponseValueByParam(value as Obj, outputField.content.param);

		return mappedValue !== undefined && mappedValue !== null && mappedValue !== '';
	});
};

export const displayBrandFlowStopModal = (
	brandName: string | undefined,
	{ displayModal }: { displayModal: (...args: unknown[]) => void }
) => {
	const flowStopBrand = listOfBrandFlowStops.find((brand) => brand === brandName?.toUpperCase());

	if (!flowStopBrand) {
		return false;
	}

	displayModal(
		`${flowStopBrand} Selected`,
		'',
		`You have selected ${flowStopBrand} as the car brand.`,
		null,
		null,
		null,
		null,
		true
	);

	return true;
};
